const GET_DEFAULT_CONTAINER_PROPS = () => ({
  oldValuePosition: "right"
});
export {
  GET_DEFAULT_CONTAINER_PROPS
};
